module.exports = __webpack_public_path__ + "assets/33a434fc84e1e7a05eb7d12337aa2ef9.png";